import { RatingAssumption } from "../../deal-builder/services/utils/primary-constants.ts";

export function ratingToNumber(rating: RatingAssumption): number {
    switch(rating) {
    case RatingAssumption.BBBMinus:
        return 1;
    case RatingAssumption.BBB:
        return 2;
    case RatingAssumption.BBBPlus:
        return 3;
    case RatingAssumption.AMinus:
        return 4;
    case RatingAssumption.A:
        return 5;
    case RatingAssumption.APlus:
        return 6;
    case RatingAssumption.AAMinus:
        return 7;
    case RatingAssumption.AA:
        return 8;
    case RatingAssumption.AAPlus:
        return 9;
    case RatingAssumption.AAA:
        return 10;
    }
}
